// Print framing only: source coordinates and geospatial measurements stay intact.
export function pdfDiagramLayout(job){
 const points=(job.drawings||[]).flatMap(d=>d.pts||[]).filter(p=>Number.isFinite(p[0])&&Number.isFinite(p[1]));
 for(const m of job.markers||[]){
  if(!Number.isFinite(m.x)||!Number.isFinite(m.y))continue;
  const size=Number(m.fontSize)||14,lines=String(m.label||'').split('+');
  const halfW=Math.max(...lines.map(l=>l.length),1)*size*.4+8,halfH=lines.length*size*.7+8;
  points.push([m.x-halfW,m.y-halfH],[m.x+halfW,m.y+halfH]);
 }
 if(!points.length)return null;
 const minX=Math.min(...points.map(p=>p[0])),maxX=Math.max(...points.map(p=>p[0]));
 const minY=Math.min(...points.map(p=>p[1])),maxY=Math.max(...points.map(p=>p[1]));
 const width=1024,height=640,padding=48,heading=job.address?32:0;
 const scale=Math.min((width-padding*2)/Math.max(1,maxX-minX),(height-padding*2-heading)/Math.max(1,maxY-minY));
 return {width,height,scale,x:width/2-(minX+maxX)/2*scale,y:heading+(height-heading)/2-(minY+maxY)/2*scale};
}
